<template>
  <div class="col-lg-3 col-md-6 col-xs-12">
    <span class="sub-title me-2">{{ label }}:</span>
    <span>{{ value }}</span>
  </div>
</template>

<script>
export default {
  name: 'TransactionInfoItem',
  props: {
    label: String,
    value: String,
  },
}
</script>

<style scoped>
.sub-title {
  color: var(--color-66);
}
</style>
